import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Self-hosted fonts — eliminates Google Fonts CDN requests that trigger
// Edge/Safari Tracking Prevention "blocked access to storage" warnings.
import "@fontsource/plus-jakarta-sans/400.css";
import "@fontsource/plus-jakarta-sans/500.css";
import "@fontsource/plus-jakarta-sans/600.css";
import "@fontsource/plus-jakarta-sans/700.css";
import "@fontsource/plus-jakarta-sans/800.css";
import "@fontsource/ibm-plex-sans-arabic/400.css";
import "@fontsource/ibm-plex-sans-arabic/500.css";
import "@fontsource/ibm-plex-sans-arabic/600.css";
import "@fontsource/ibm-plex-sans-arabic/700.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";

import "./index.css";
import ThemeContextProvider from "./theme/ThemeContextProvider.jsx";
import App from "./App.jsx";
import "./i18n/index.js";
import { BrowserRouter } from "react-router-dom";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <ThemeContextProvider>
        <App />
    </ThemeContextProvider>
  </StrictMode>
);
